import { htmlAttributes } from '../constants';
import { isBeaconSent, isVisible, triggerBeacon } from './checkVisibilityHelpers';

export const checkVisibility = (containerSelector) => {
  const container = document.querySelector(containerSelector);
  const elements = (container || document)
    ?.querySelectorAll(`[${htmlAttributes.ONVIEW_BEACON_NUCLEUS}], [${htmlAttributes.DATA_ONVIEW_BEACON_NUCLEUS}]`);

  elements.forEach((el) => {
    if (!isBeaconSent(el) && isVisible(window, el)) {
      setTimeout(() => {
        if (!isBeaconSent(el) && isVisible(window, el)) {
          triggerBeacon(el);
        }
      }, 1000);
    }
  });
};
